import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import '@styles/Menu/style.css'
import classNames from 'classnames'

interface IMenuProps {
  horizontal?: boolean
  menuTitle?: JSX.Element
  children?: any
  onTitleClick?: () => void
  openState?: boolean
  className?: string
  style?: React.CSSProperties
  menuListClass?: string
  menuTitleClass?: string
}

interface IMenuItemProps {
  children?: any
  hasSubMenu?: boolean
  onTitleClick?: () => void
  className?: string
  style?: React.CSSProperties
}

export const Menu: React.FC<IMenuProps> = (props): JSX.Element => {
  const {
    menuTitle,
    children,
    horizontal,
    onTitleClick,
    openState,
    className,
    style,
    menuTitleClass
  } = props
  const [showMenuItems, setShowMenuItems] = useState(false) // default expanded list

  useEffect(() => {
    if (openState !== undefined) {
      setShowMenuItems(openState)
    }
  }, [openState])

  return (
    <div
      className={cn(['menu', { 'menu-horizontal': horizontal }], className)}
      style={style}
    >
      <div
        onClick={() => {
          setShowMenuItems(!showMenuItems)
          onTitleClick && onTitleClick() // call any external handlers, if passed
        }}
        className={classNames('menu-title', menuTitleClass)}
      >
        {menuTitle}
      </div>
      {showMenuItems && children && (
        <ul
          className={cn([
            'menu-list',
            { 'menu-list-horizontal': horizontal },
            props.menuListClass
          ])}
        >
          {children}
        </ul>
      )}
    </div>
  )
}

export const MenuItem: React.FC<IMenuItemProps> = (props): JSX.Element => {
  const { children, hasSubMenu, onTitleClick, className, style } = props
  return (
    <li
      style={style}
      className={cn(
        {
          'menu-list-independent': !hasSubMenu
        },
        className
      )}
      onClick={onTitleClick}
    >
      {children}
    </li>
  )
}

MenuItem.defaultProps = {
  hasSubMenu: false
}
